import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import LoadingSpinner from "../components/LoadingSpinner";

const SigninError: React.FC = () => {
    const [err, setErr] = useState<string>("");
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        setErr(queryParams.get("emsg") ?? "");
    }, [location.search]);

    setTimeout(() => {
        window.location.href = `${
            import.meta.env.VITE_BFF_PROXY
        }/bff/login?returnUrl=${import.meta.env.VITE_SITE_BASE}${
            err.length > 0 ? "&emsg=" + err : ""
        }`;
        return "";
    }, 300);

    return <LoadingSpinner />;
};
export default SigninError;
